<template>
    <el-dialog
        :visible="isVisible"
        @close="hide"
        :title="title"
        :destroy-on-close="true"
    >
        <loading v-if="!isInitialized"></loading>
        <do-not-contact-form
            v-if="isInitialized"
            v-bind="formData"
            @stored="onStored"
        ></do-not-contact-form>
    </el-dialog>
</template>

<script>
  import BaseDialogFormWrapper from '../../components/dialog-form-wrapper';
  import Loading from '../../components/loading';
  import eventBus from '../../event-bus';
  import DoNotContactForm from '../../components/do-not-contact/form';

  export default {
    extends: BaseDialogFormWrapper,

    components: {
      Loading,
      DoNotContactForm
    },

    computed: {
      /**
       * @return {string}
       */
      title() {
        if (!this.isInitialized) {
          return 'Loading ...';
        } else if (_.get(this.formData, 'model.id')) {
          return 'Edit Do Not Contact'
        }

        return 'Create Do Not Contact'
      },
    },

    methods: {
      /**
       * @param {string|undefined} message
       */
      onStored({message}) {
        _.isString(message) && this.$message.success(message);
        this.hide();
        eventBus.$emit('refresh-do-not-contact-table');
      },
    },

    created() {
      eventBus.$on('show-add-do-not-contact-dialog', this.show);
    },

    beforeDestroy() {
      eventBus.$off('show-add-do-not-contact-dialog', this.show);
    }

  }
</script>
